export const AUTHENTICATE_LANDING = 'events/AUTHENTICATE_LANDING';

/**
 * @param confId
 * @param guest
 * @param guestEmail
 * @return {{type: string, payload: {confId: *, guest: *}}}
 */
export const authenticateLanding = (confId, guest, guestEmail, attId) => ({
  type: AUTHENTICATE_LANDING,
  payload: {
    confId, guest, guestEmail, attId,
  },
});
